module.exports = __webpack_public_path__ + "static/media/SFC Type.9796a4ac.png";